// extracted by mini-css-extract-plugin
module.exports = {"root":"input-text_root__3ocZI","input":"input-text_input__23gWO","blink":"input-text_blink__XWZr5"};